import React, { useMemo, useState } from 'react';

function LogisticsSelectionModal({
  isOpen,
  logisticsList,
  selectedLogisticsId,
  onSelect,
  onClose,
}) {
  const [searchText, setSearchText] = useState('');

  const filteredLogistics = useMemo(() => {
    return logisticsList.filter((item) => {
      const name = item.name?.toLowerCase() || '';
      const code = item.code?.toLowerCase() || '';
      const search = searchText.toLowerCase();

      return name.includes(search) || code.includes(search);
    });
  }, [logisticsList, searchText]);

  if (!isOpen) return null;

  return (
    <div style={overlayStyle} onClick={() => onClose()}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle}>
          <div>
            <h2 style={{ margin: 0 }}>Select Logistics Person</h2>
            <p style={{ marginTop: '6px', color: '#64748b' }}>
              Please select a logistics person to continue data entry.
            </p>
          </div>

          <button type="button" onClick={() => onClose()} style={closeButtonStyle}>
            ✕
          </button>
        </div>

        <div style={{ marginTop: '16px' }}>
          <input
            type="text"
            placeholder="Search logistics by name or code"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={searchInputStyle}
          />
        </div>

        <div style={{ marginTop: '20px' }}>
          {filteredLogistics.length > 0 ? (
            filteredLogistics.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => {
                  onSelect(item);
                }}
                style={{
                  ...cardStyle,
                  border:
                    selectedLogisticsId === item.id
                      ? '2px solid #0f172a'
                      : '1px solid #dbeafe',
                }}
              >
                <div>
                  <strong>{item.name}</strong>
                </div>
                <div style={{ marginTop: '6px', color: '#475569' }}>
                  {item.code || 'No Code'}
                </div>
              </button>
            ))
          ) : (
            <div style={emptyStateStyle}>No logistics found</div>
          )}
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0,0,0,0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  margin:'0 15px',
};

const modalStyle = {
  width: '500px',
  maxWidth: '90%',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '24px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '12px',
};

const closeButtonStyle = {
  border: 'none',
  background: '#f1f5f9',
  borderRadius: '6px',
  width: '32px',
  height: '32px',
  cursor: 'pointer',
  fontSize: '16px',
};

const cardStyle = {
  width: '100%',
  textAlign: 'left',
  padding: '14px 16px',
  marginBottom: '12px',
  borderRadius: '10px',
  backgroundColor: '#f8fafc',
  cursor: 'pointer',
};

const searchInputStyle = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  fontSize: '14px',
  boxSizing: 'border-box',
};

const emptyStateStyle = {
  padding: '14px',
  textAlign: 'center',
  color: '#64748b',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  marginTop: '12px',
};

export default LogisticsSelectionModal;